export default __webpack_public_path__ + "static/media/news1.65238ab4.png";